export default __webpack_public_path__ + "static/media/imc-gray.272a3d5e.svg";